import { ChangeEvent, useState } from 'react';
import { toast } from 'react-hot-toast';
import Input from '../../../../components/common/Input/Input';
import { Button } from '../../../../components/ui/Button/Button';
import S from './UpdateSchemaModalStyles';
import usePatchAudioSchema from '../../../../API/hooks/devices/usePatchAudioSchema';
import useGetFleetId from '../../../../API/hooks/useGetFleetId';
import { AudioSchema } from '../../../../API/types/AudioSchemas';

type Props = {
  schema: AudioSchema;
  onClose: () => void;
};

function UpdateSchemaModal({
  schema, onClose,
}: Props): JSX.Element {
  const isDefaultSchema = schema.name === 'default';
  const [name, setName] = useState(schema.name);
  const fleetId = useGetFleetId();
  const onSubmitSuccess = (): any => {
    toast.success('Schema was updated');
    onClose();
  };
  const onSubmitFail = (errorMessage: string): any => {
    toast.error(`Schema updating failed: ${errorMessage}`);
    // onClose();
  };
  const { mutate } = usePatchAudioSchema(onSubmitSuccess, onSubmitFail);

  const handleInputChange = (e: ChangeEvent<any>): void => {
    setName(e.target.value);
  };

  return (
    <S.Wrapper>
      <Input
        name="name"
        label="Schema name"
        type="text"
        value={name}
        placeholder="Type schema name"
        onChange={handleInputChange}
        disabled={isDefaultSchema}
      />
      <div className="actions">
        <Button
          padding="7px 40px"
          disabled={!name || name === ''}
          onClick={() => mutate({
            fleetId,
            name,
            audioSchemaId: schema._id,
          })}
        >
          Update
        </Button>
        <Button
          padding="7px 40px"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default UpdateSchemaModal;
